/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:31:47 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2021-01-20 10:21:50
 * @param  apiUrl:域名地址
 * @param  routerMode:路由模式
 */
let protocol = location.protocol;

let apiUrl = '';
let routerMode = 'history';
if (process.env.NODE_ENV == 'development') {
    // apiUrl = protocol + "//zfyx.xmq.dev.cricwifi.com/api/";
    apiUrl = protocol + "//data.youcaiyun.com/api/";
} else if (process.env.NODE_ENV == 'production') {
    apiUrl = protocol + "//data.youcaiyun.com/api/";
}
export default {
    apiUrl,
    routerMode
}